"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Search from foundation/Search
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Search = createSVGIcon(
  <g strokeWidth="1" fill="none" fillRule="evenodd">
    <g
      transform="translate(1) translate(0 .727)"
      stroke="currentColor"
      strokeWidth="1.1"
    >
      <ellipse cx="5.958" cy="6.233" rx="5.958" ry="6.233" />
      <path d="m10.348 11.08 3.152 3.693" strokeLinecap="square" />
    </g>
  </g>,
  "Search",
  { viewBox: "0 0 16 17", titleAccess: "Search" }
);
